import { Box, Button, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { settingsAtom } from '../../atoms/Settings';
import { useThemeColor } from '../../hooks/useThemeColor';
import { Blog } from '../../interfaces/Blog/Blog';
import { getBlogs } from '../../api/Blog';
import { BlogCard } from './BlogCard';
import { useIsMobile } from '../../hooks/useIsMobile';

export const Blogs = () => {
  const settings = useRecoilValue(settingsAtom);

  const [blogs, setBlogs] = useState<Blog[]>([]);

  const navigate = useNavigate();

  const { primary, secondary, ternary } = useThemeColor();
  const isMobile = useIsMobile();

  useEffect(() => {
    getBlogs()
      .then((b) => setBlogs(b))
      .catch((err) => toast.error(err.message));
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        p: isMobile ? 3 : 10,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'stretch',
        gap: 2.5,
        backgroundColor: settings.settingsV1.storefront_blogs_color,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2.5,
          justifyContent: 'center',
        }}
      >
        <Typography fontSize='36px' fontWeight={600} sx={{ color: ternary }}>
          {settings.settingsV1.blog_text}
        </Typography>

        <Typography
          width={250}
          fontSize='16px'
          fontWeight={500}
          sx={{ color: ternary }}
        >
          {settings.settingsV1.blog_description ||
            'En yeni trendler, cilt bakımı sırları ve fazlası… Yeni blog yazılarımıza göz atın!'}
        </Typography>

        <Button
          onClick={() => navigate('/blog')}
          sx={{
            fontWeight: 700,
            fontSize: '13px',
            padding: '8px 15px',
            color: secondary,
            backgroundColor: primary,
            transition: 'background-color 0.3s ease',
            textTransform: 'none',
            width: 'fit-content',
            '&:hover': {
              backgroundColor: ternary,
            },
          }}
        >
          Tüm İçerikleri Gör
        </Button>
      </Box>

      <Box sx={{ ml: 'auto' }} />

      {isMobile ? (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: 2.5,
            overflowX: 'auto',
            alignItems: 'stretch', // ensures children stretch vertically
          }}
        >
          {blogs.slice(0, 3).map((blog, i) => (
            <Box key={i} sx={{ minWidth: 250, display: 'flex' }}>
              <BlogCard blog={blog} sx={{ flex: 1 }} />
            </Box>
          ))}
        </Box>
      ) : (
        blogs.slice(0, 3).map((blog, i) => <BlogCard key={i} blog={blog} />)
      )}
    </Box>
  );
};
